<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Layout from '@/components/Layout.vue'
import PublicLayout from '@/components/PublicLayout.vue'

const route = useRoute()
const layoutComponent = computed(() => {
  if (route.meta.layout === 'public') return PublicLayout
  return Layout // default
})
</script>

<template>
  <component :is="layoutComponent" />
</template>
